import cx from 'classnames';
import type { getBrandConfig } from './brand-configs';

export function getBrandClassName(config: ReturnType<typeof getBrandConfig>) {
  const brandCode = config.brandCode.toLowerCase();

  const themeClass = ['aq', 'ee'].includes(brandCode) ? 'theme-hi' : `theme-${brandCode}`;

  return cx(themeClass, {
    [`${themeClass}-refresh`]: config.isBrandRefresh,
    'legacy-surfaces': config.surfaceConfig.isLegacy,
  });
}
